import { get } from 'lib/API';

export const getCurrencies = async (
    _: any[],
    { token }: any
) => {
    return await get('v1/currencies', token);
}

